export default __webpack_public_path__ + "static/media/doradeniz1.86fd153b.jpg";